import { CSSProperties } from "react";

import { Link, LinkProps } from "@chakra-ui/next-js";
import { Box, HStack, Text } from "@chakra-ui/react";

import { ExternalLinkIcon } from "@/components/shared/ReleaseIcons";

type Props = {
  href: string;
  text: string;
  alignItems?: Pick<CSSProperties, "alignItems">;
};
export default function ExternalLink({ href, text, alignItems = "center", ...props }: Props & LinkProps) {
  return (
    <Link isExternal href={href} {...props}>
      <HStack alignItems={alignItems}>
        <Text wordBreak="break-word">{text}</Text>
        <Box>
          <ExternalLinkIcon />
        </Box>
      </HStack>
    </Link>
  );
}
